import { render } from "./404.vue?vue&type=template&id=57e86caf&scoped=true&ts=true"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=57e86caf&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/vars.autocall.ai/vars.autocall.ai/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e86caf"]])

export default __exports__